// extracted by mini-css-extract-plugin
export default {"section":"ticketManagement_section__aVEd1","description":"ticketManagement_description__lS7Gq","employee_select_wrapper":"ticketManagement_employee_select_wrapper__p5w0L"};